<template>
    <div
        class="mx-3"
        style="width: 100%"
        :style="{
            maxHeight: showCommentForm === false ? '100%' : '300px'
        }"
    >
        <div class="row">
            <div
                v-for="comentario in comentarios"
                :key="comentario.id"
                class="col-12"
            >
                <div class="card mb-0">
                    <div class="card-body p-0 mb-2">
                        <div
                            class="p-3 border-0 rounded-lg comentario-mensagem"
                            :class="
                                meuComentario(comentario)
                                    ? 'sb4 bg-azul'
                                    : 'sb5 bg-cinza'
                            "
                            :style="{
                                float: meuComentario(comentario)
                                    ? 'right'
                                    : 'left'
                            }"
                            v-html="comentario.mensagem"
                        ></div>
                    </div>

                    <div class="card-footer pb-0 border-0">
                        <div class="media mb-2">
                            <div class="media-body">
                                <div class="row">
                                    <div
                                        class="col-12 d-flex align-items-center px-0"
                                        :class="
                                            meuComentario(comentario)
                                                ? 'justify-content-end'
                                                : 'justify-content-start'
                                        "
                                    >
                                        <div
                                            class="d-flex align-items-center"
                                            :class="
                                                meuComentario(comentario)
                                                    ? 'justify-content-end flex-row-reverse'
                                                    : 'justify-content-start'
                                            "
                                        >
                                            <img
                                                v-if="comentario.avatar"
                                                :alt="$t('User avatar')"
                                                :src="comentario.avatar"
                                                :title="nomeUsuario(comentario)"
                                                class="rounded-circle"
                                                style="width: 40px"
                                            />

                                            <div
                                                style="line-height: 18px"
                                                :class="
                                                    meuComentario(comentario)
                                                        ? 'text-right mr-2'
                                                        : 'text-left ml-2'
                                                "
                                            >
                                                <b>
                                                    {{ nomeUsuario(comentario) }}
                                                </b>

                                                <br />

                                                <small class="text-muted">
                                                    {{ emailUsuario(comentario) }}
                                                    -
                                                    {{ comentario.cadastrado }}
                                                </small>

                                                <div class="mt-1 no-print">
                                                    <button
                                                        v-if="
                                                            reply &&
                                                            showCommentForm !== false
                                                        "
                                                        type="button"
                                                        class="btn btn-link btn-sm p-0 mr-2"
                                                        title="Responder comentário"
                                                        :disabled="busy"
                                                        @click="scrollTop(comentario)"
                                                    >
                                                        <i
                                                            class="mdi mdi-message-arrow-right"
                                                        ></i>
                                                        Responder
                                                    </button>

                                                    <button
                                                        v-if="podeEditar(comentario)"
                                                        type="button"
                                                        class="btn btn-link btn-sm p-0"
                                                        title="Editar comentário"
                                                        :disabled="busy"
                                                        @click="
                                                            encaminharEdicao(comentario)
                                                        "
                                                    >
                                                        <i class="mdi mdi-pencil"></i>
                                                        Editar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    v-if="respostas(comentario).length > 0"
                    class="col-12 p-3 mb-3 no-print border rounded"
                >
                    <div class="row d-flex justify-content-end px-2 mb-2">
                        <small>
                            Resposta(s) ao comentário acima
                        </small>
                    </div>

                    <comentarios
                        :comentarios="respostas(comentario)"
                        :reply="false"
                        :allow-edit="allowEdit"
                        :show-comment-form="showCommentForm"
                        :busy="busy"
                        @scroll="scrollTop"
                        @editar="encaminharEdicao"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Comentarios",

    props: {
        comentarios: {
            type: [Array, Object],
            default: () => [],
        },

        reply: {
            type: Boolean,
            default: false,
        },

        showCommentForm: {
            type: Boolean,
            default: true,
        },

        allowEdit: {
            type: Boolean,
            default: false,
        },

        busy: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        meuComentario(comentario) {
            const usuario =
                this.$store &&
                this.$store.state &&
                this.$store.state.user;

            return Boolean(
                usuario &&
                usuario.id != null &&
                comentario.usuario &&
                comentario.usuario.id != null &&
                String(comentario.usuario.id) === String(usuario.id)
            );
        },

        podeEditar(comentario) {
            return (
                this.allowEdit &&
                this.showCommentForm !== false &&
                this.meuComentario(comentario)
            );
        },

        nomeUsuario(comentario) {
            return (
                (comentario.usuario && comentario.usuario.name) ||
                "Usuário não informado"
            );
        },

        emailUsuario(comentario) {
            return (
                (comentario.usuario && comentario.usuario.email) ||
                ""
            );
        },

        respostas(comentario) {
            return Array.isArray(comentario.comentario_pai)
                ? comentario.comentario_pai
                : [];
        },

        scrollTop(comentario) {
            if (
                !this.busy &&
                this.reply &&
                this.showCommentForm !== false
            ) {
                this.$emit("scroll", comentario);
            }
        },

        encaminharEdicao(comentario) {
            if (!this.busy && this.podeEditar(comentario)) {
                this.$emit("editar", comentario);
            }
        },
    },
};
</script>

<style lang="css">
.comentario-mensagem {
    width: fit-content;
    min-width: 200px;
    max-width: 100%;
    overflow-wrap: break-word;
}

.sb4:before {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    border-left: 20px solid transparent;
    border-right: 12px solid #ebeef7;
    border-top: 5px solid #ebeef7;
    border-bottom: 7px solid transparent;
    right: 18px;
    bottom: -11px;
}

.sb5:before {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    border-left: 12px solid #f5f5f5;
    border-right: 12px solid transparent;
    border-top: 5px solid #f5f5f5;
    border-bottom: 7px solid transparent;
    left: 18px;
    bottom: -11px;
}

.bg-azul {
    background: #ebeef7;
    color: #383838 !important;
}

.bg-cinza {
    background: #f5f5f5;
    color: #383838 !important;
}
</style>